import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export const ServerService = {
  restart: () => {
    return axios.post(`${API_BASE_URL}/server/restart`);
  }
};